const ACCESS_TOKEN_COOKIE_NAME = 'accessToken';
const EXPIRES_AT_COOKIE_NAME = 'expiresAt';

const GOOGLE_OAUTH_SCOPES =
    'https://www.googleapis.com/auth/userinfo.profile https://www.googleapis.com/auth/userinfo.email';

const USER_SELECTED_ORG_UID = 'userSelectedOrgUid';

export {ACCESS_TOKEN_COOKIE_NAME, EXPIRES_AT_COOKIE_NAME, GOOGLE_OAUTH_SCOPES, USER_SELECTED_ORG_UID};
